import { Button } from "components/ui/button";
import { X } from "lucide-react";
import { closeSnackbar, SnackbarKey } from "notistack";

interface CloseButtonProps {
  snackbarId: SnackbarKey;
}

const CloseButton = (props: CloseButtonProps) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => closeSnackbar(props.snackbarId)}
      aria-label="Close"
      className="text-white hover:text-white hover:bg-white/10"
    >
      <X />
    </Button>
  );
};

export { CloseButton };
